import { laptopMaxXL, largeTabletMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import { Row } from '@propertypal/web-ui/src/layout';
import styled from 'styled-components';

export const TitleBox = styled.div`
  margin: 60px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 15px;

  @media (${largeTabletMax}) {
    margin: 30px auto;
  }
`;

export const AgentLogo = styled.img`
  max-width: 200px;
  max-height: 80px;
  align-self: center;
  margin-bottom: 15px;
`;

export const SummaryBox = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 60px;

  @media (${largeTabletMax}) {
    flex-direction: column;
    margin-top: 30px;
  }
`;

export const BranchesWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const FormContainer = styled.div`
  width: 415px;
  margin-left: 30px;

  @media (${largeTabletMax}) {
    width: 100%;
    margin: 60px 0;
  }
`;

export const FormBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.1);
  margin-bottom: 60px;
`;

export const Accreditations = styled.div`
  background: ${(props) => props.theme.backgroundLighter};
  padding: 30px 0;

  h3 {
    color: ${(props) => props.theme.textDark};
    text-align: center;
  }

  ${Row} {
    margin-top: 30px;
    justify-content: center;
    flex-wrap: wrap;
    padding: 0 15px;
  }
`;

export const LinkList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 30px;

  a {
    width: 33.3%;
    margin-bottom: 20px;
    padding-right: 15px;
    display: block;
    color: ${(props) => props.theme.primary};
    text-decoration: underline;

    &:hover {
      color: ${(props) => props.theme.backgroundMid};
    }
  }

  @media (${mobileXXLargeMax}) {
    flex-direction: column;

    a {
      width: 100%;
    }
  }
`;

export const OtherBranches = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-column-gap: 20px;
  grid-row-gap: 30px;
  margin: 30px 0 60px;

  @media (${laptopMaxXL}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (${mobileXXLargeMax}) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;
